import { getTimelineValue } from '@/components/common/Filter/TimelineFilter/utils'
import {
    CustomReportFiltersParams,
    GetPayablesSummaryRequestParams,
} from '@/hooks'

export const processPayablesFilters = (
    filters: CustomReportFiltersParams
): GetPayablesSummaryRequestParams => {
    const { startDate, endDate } =
        'startDate' in filters && 'endDate' in filters
            ? { startDate: filters.startDate, endDate: filters.endDate }
            : getTimelineValue(filters.timeline)

    return {
        'nodeIds[]': filters.nodeIds.join(','),
        'commodityTypeIds[]': filters.commodityTypeIds?.join(','),
        startDate,
        endDate,
        'providerIds[]': filters.providerIds?.join(','),
        'contractIds[]': filters.contractIds?.join(','),
        'panIds[]': filters.panIds?.join(','),
        'tagIds[]': filters.tagIds?.join(','),
        'facilityIds[]': filters.facilityIds?.join(','),
        'usnAccountIds[]': filters.usnAccountIds?.join(','),
        'invoiceNumbers[]': filters.invoiceNumbers?.join(','),
    }
}
